import 'hammerjs';

import {AppRoutingModule} from './app-routing.module';
import {BrowserModule} from '@angular/platform-browser';
import {NgModule, Provider} from '@angular/core';

import {AppComponent} from './app.component';
import {ReactiveFormsModule} from '@angular/forms';
import {AuthenticationModule} from './authentication/authentication.module';
import {NavigationModule} from './navigation/navigation.module';
import {PickUpListModule} from './pick-up-list/pick-up-list.module';
import {HelpModule} from './help/help.module';
import {MAT_DIALOG_SCROLL_STRATEGY} from '@angular/material';
import {SCROLL_STRATEGY_PROVIDER_FACTORY} from './scroll-strategy';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {environment} from '../environments/environment';
import {StubInterceptor} from './stub-interceptor';
import {CookieModule} from './cookie/cookie.module';

const providers: Provider[] = [
  {provide: MAT_DIALOG_SCROLL_STRATEGY, useFactory: SCROLL_STRATEGY_PROVIDER_FACTORY}
];

if (environment.useStubInterceptor) {
  providers.push({provide: HTTP_INTERCEPTORS, useClass: StubInterceptor, multi: true});
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    ReactiveFormsModule,
    NavigationModule,
    AuthenticationModule,
    PickUpListModule,
    AppRoutingModule,
    HelpModule,
    CookieModule
  ],
  providers,
  bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts